import styles from './Paginator.module.css';

export default function Paginator({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
  onItemsPerPageChange
}) {
  const totalPages = Math.ceil(totalItems / itemsPerPage) || 1;

  // Generate page numbers to display with smart ellipsis
  function getPageNumbers() {
    const pages = [];
    const delta = 2; // numbers to show before/after current page

    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - delta && i <= currentPage + delta)
      ) {
        pages.push(i);
      } else if (
        i === currentPage - delta - 1 ||
        i === currentPage + delta + 1
      ) {
        pages.push('...');
      }
    }

    // Deduplicate consecutive ellipses
    return pages.filter((item, index) => {
      if (item === '...') {
        return pages[index - 1] !== '...';
      }
      return true;
    });
  }

  const startIdx = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endIdx = Math.min(currentPage * itemsPerPage, totalItems);
  const pageNumbers = getPageNumbers();

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        Showing {startIdx} to {endIdx} of {totalItems} entries
      </div>

      <div className={styles.controls}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ fontSize: 11, color: 'var(--text3)' }}>Per Page:</span>
          <select
            className={styles.pageSizeSelect}
            value={itemsPerPage}
            onChange={e => {
              onItemsPerPageChange(Number(e.target.value));
              onPageChange(1);
            }}
          >
            {[5, 10, 20, 50, 100].map(size => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>

        <div className={styles.pages}>
          <button
            className={styles.btn}
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            title="Previous Page"
          >
            &lt;
          </button>

          {pageNumbers.map((num, idx) => (
            num === '...' ? (
              <span key={`dots-${idx}`} className={styles.dots}>
                ...
              </span>
            ) : (
              <button
                key={num}
                className={`${styles.btn} ${num === currentPage ? styles.btnActive : ''}`}
                onClick={() => onPageChange(num)}
              >
                {num}
              </button>
            )
          ))}

          <button
            className={styles.btn}
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            title="Next Page"
          >
            &gt;
          </button>
        </div>
      </div>
    </div>
  );
}
